import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import classNames from "classnames"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import PropTypes from "prop-types"
import OrdersTable from "pages/admin/Orders/OrdersTable"
import { FilterData, IndexType } from "components/Extra"
import { OrdersGrid } from "pages/admin/Orders/OrdersGrid"
import { AssignDeliveryManModal, RejectedOrderModal } from "pages/admin/Orders/Modals"
import { CurrentTapType, PaymentStatus } from "./ordersType"
import { useTranslation } from "react-i18next"
import { Card, CardBody, Col, Row } from "reactstrap"
import { useSearchParams } from "react-router-dom"
import { FilterByDateRangeModal } from "components/Extra/FilterByDateRangeModal"

const tabs = [
  CurrentTapType.all,
  CurrentTapType.pending,
  CurrentTapType.inProgress,
  CurrentTapType.delivered,
  CurrentTapType.cancelled,
  CurrentTapType.rejected,
]

export interface Order {
  id: string
  createdDate: string
  createdBy: string
  orderStatus: CurrentTapType
  orderValue: string
  paymentStatus: PaymentStatus
  items: number
}

const ordersCardDate: {label: string; value: number}[] = [
  {
    label: "orders_totalOrders",
    value: 200,
  },
  {
    label: "orders_pending",
    value: 20,
  },
  {
    label: "orders_inProgress",
    value: 80,
  },
  {
    label: "orders_cancelled",
    value: 10,
  },
  {
    label: "orders_delivered",
    value: 50,
  },
  {
    label: "orders_rejected",
    value: 40,
  },
]

const ordersData: Order[] = [
  {
    id: "ID-145871",
    createdDate: "25 May, 2023",
    createdBy: "Amr Kamal",
    orderStatus: CurrentTapType.pending,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.pendingPayment,
    items: 2,
  },
  {
    id: "ID-145872",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    orderStatus: CurrentTapType.inProgress,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.paid,
    items: 2,
  },
  {
    id: "ID-145873",
    createdDate: "25 May, 2023",
    orderStatus: CurrentTapType.pending,
    createdBy: "Amr Kamal",
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.pendingPayment,
    items: 2,
  },
  {
    id: "ID-145874",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    orderStatus: CurrentTapType.rejected,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.paid,
    items: 2,
  },
  {
    id: "ID-145875",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    orderStatus: CurrentTapType.delivered,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.unpaid,
    items: 2,
  },
  {
    id: "ID-145876",
    createdDate: "25 May, 2023",
    createdBy: "Amr Kamal",
    orderStatus: CurrentTapType.pending,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.pendingPayment,
    items: 2,
  },
  {
    id: "ID-145877",
    createdDate: "25 May, 2023",
    createdBy: "Mohamed",
    orderStatus: CurrentTapType.cancelled,
    orderValue: "QAR 50",
    paymentStatus: PaymentStatus.unpaid,
    items: 2,
  },
]

interface OrdersProps {
  location?: any
  isDashboardPage?: boolean
}

export const Orders: React.FC<OrdersProps> = ({
  location,
  isDashboardPage,
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentTap, setCurrentTap] = useState(CurrentTapType.all)
  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [orders, setOrders] = useState<Order[]>([])
  const [filteredOrders, setFilteredOrders] = useState<Order[]>([])
  const [checkedOrders, setCheckedOrders] = useState<Order[]>([])
  const [openRejectedOrderModal, setOpenRejectedOrderModal] = useState<{
    open: boolean
    order: Order | null
  }>({
    open: false,
    order: null,
  })
  const [openAssignDeliveryManModal, setOpenAssignDeliveryManModal] = useState<{
    open: boolean
    order: Order | null
  }>({
    open: false,
    order: null,
  })

  const navigate = useNavigate()
  const { t } = useTranslation()

  useEffect(() => {
    setOrders(ordersData)
    setFilteredOrders(ordersData)
  }, [])

  const checkedOrderHandler = useCallback((order: Order) => {
    setCheckedOrders(prev =>
      prev.includes(order) ? prev.filter(o => o !== order) : [...prev, order]
    )
  }, [])

  const changeTabHandler = useCallback(
    (tab: CurrentTapType) => {
      setCurrentTap(tab)
      if (tab === CurrentTapType.all) {
        setFilteredOrders(orders)
      } else {
        setFilteredOrders(orders.filter(o => o.orderStatus === tab))
      }
    },
    [orders, setCurrentTap]
  )

    useEffect(() => {
      const tabParam = searchParams.get("tab") as CurrentTapType
      if (tabParam && Object.values(CurrentTapType).includes(tabParam)) {
        changeTabHandler(tabParam)
      }
    }, [changeTabHandler])

  const acceptHandler = useCallback((order: Order) => {
    setOpenAssignDeliveryManModal({
      open: true,
      order: order,
    })
  }, [])
  const rejectHandler = useCallback((order: Order) => {
    setOpenRejectedOrderModal({
      open: true,
      order: order,
    })
  }, [])
  const viewDetailsHandler = useCallback((order: Order) => {
    navigate(`/orders/${order.id}`)
  }, [])

  const isAllChecked = useMemo(() => {
    return orders.length > 0 && checkedOrders.length === orders.length
  }, [orders, checkedOrders])

  const toggleAllOrders = useCallback(() => {
    setCheckedOrders(isAllChecked ? [] : orders)
  }, [isAllChecked, orders])

    const onDateRangeChange = (startDate: string, endDate: string) => {
      console.log("Selected date range:", startDate, "to", endDate)
    }

  if (isDashboardPage) {
    return (
      <>
        <div className="">
          <FilterData
            data={orders}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            bearerFilteredData={setFilteredOrders}
            showFilterBtnInsteadOfToggle
          />
        </div>

        {/* Modals */}
        <RejectedOrderModal
          isOpen={openRejectedOrderModal.open}
          order={openRejectedOrderModal.order}
          toggle={() =>
            setOpenRejectedOrderModal({
              open: false,
              order: null,
            })
          }
        />
        <AssignDeliveryManModal
          isOpen={openAssignDeliveryManModal.open}
          order={openAssignDeliveryManModal.order}
          toggle={() =>
            setOpenAssignDeliveryManModal({
              open: false,
              order: null,
            })
          }
        />

        <OrdersTable
          orders={filteredOrders}
          isAllChecked={isAllChecked}
          checkedOrders={checkedOrders}
          toggleAllOrders={toggleAllOrders}
          checkedOrderHandler={checkedOrderHandler}
          acceptHandler={acceptHandler}
          rejectHandler={rejectHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      </>
    )
  }

  return (
    <div className="page-content d-flex flex-column">
      <div className="container-fluid p-0">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("orders_orders")}
        />
        <FilterByDateRangeModal
          onDateRangeChange={onDateRangeChange}
          className="mb-3"
        />
        <Row>
          {ordersCardDate.map((one, key) => (
            <Col
              md="4"
              lg="2.4"
              key={"_col_" + key}
              className="col-lg-6ths"
              style={{ height: "fit-content" }}
            >
              <Card className="mini-stats-wid shadow-md rounded-3">
                <CardBody>
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <p className="text-muted fw-medium text-capitalize">
                        {t(one.label)}
                      </p>
                      <div className="d-flex gap-1 align-items-baseline justify-content-start">
                        <h4 className="mb-0">{one.value}</h4>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>

        <ul className="nav nav-pills mb-3 px-2 ">
          {tabs.map(tab => (
            <li
              className="nav-item"
              style={{ flex: 1, textAlign: "center" }}
              key={tab}
            >
              <Link
                to="#"
                className={classNames(
                  { active: currentTap === tab },
                  "nav-link"
                )}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => changeTabHandler(tab)}
              >
                {t(tab)}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <FilterData
        data={orders}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredOrders}
        showSearchFilterBtn
      />

      {/* Modals */}
      <RejectedOrderModal
        isOpen={openRejectedOrderModal.open}
        order={openRejectedOrderModal.order}
        toggle={() =>
          setOpenRejectedOrderModal({
            open: false,
            order: null,
          })
        }
      />
      <AssignDeliveryManModal
        isOpen={openAssignDeliveryManModal.open}
        order={openAssignDeliveryManModal.order}
        toggle={() =>
          setOpenAssignDeliveryManModal({
            open: false,
            order: null,
          })
        }
      />

      {activeTab == "list-ul" ? (
        <OrdersTable
          orders={filteredOrders}
          isAllChecked={isAllChecked}
          checkedOrders={checkedOrders}
          toggleAllOrders={toggleAllOrders}
          checkedOrderHandler={checkedOrderHandler}
          acceptHandler={acceptHandler}
          rejectHandler={rejectHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      ) : (
        <OrdersGrid
          orders={filteredOrders}
          acceptHandler={acceptHandler}
          rejectHandler={rejectHandler}
          viewDetailsHandler={viewDetailsHandler}
        />
      )}
    </div>
  )
}

Orders.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(Orders))
